"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import AvatarView from '../../../../../../../../views/AvatarView.mjs';
import HeadingView from '../../../../../../../../views/HeadingView.mjs';
import ListItemViewContentView from '../../../../../../../../views/ListItemViewContentView.mjs';
import SkeletonTextView from '../../../../../../../../views/SkeletonTextView.mjs';
import SkeletonView from '../../../../../../../../views/SkeletonView.mjs';
import TextView from '../../../../../../../../views/TextView.mjs';

const ListItemSkeletonView = (props) => {
  const { viewMode } = props;
  const showTiles = viewMode === "tiles";
  return /* @__PURE__ */ jsx(
    ListItemViewContentView,
    {
      viewMode,
      title: /* @__PURE__ */ jsx(HeadingView, { children: /* @__PURE__ */ jsx(SkeletonTextView, { width: "200px" }) }),
      avatar: showTiles && /* @__PURE__ */ jsx(AvatarView, { children: /* @__PURE__ */ jsx(SkeletonView, { style: { aspectRatio: 16 / 9 } }) }),
      subTitle: /* @__PURE__ */ jsx(TextView, { children: /* @__PURE__ */ jsx(SkeletonTextView, { width: "300px" }) })
    }
  );
};

export { ListItemSkeletonView };
//# sourceMappingURL=ListItemSkeletonView.mjs.map
